import * as React from 'react';
import { StepButton as MatStepButton, SxProps, Theme } from '@mui/material';

export interface StepButtonProps {
  icon?: number;
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  focusRipple?: boolean;
  disableRipple?: boolean;
  sx?: SxProps<Theme>;
}

const StepButton: React.FC<StepButtonProps> = ({ children, onClick, icon, focusRipple, disableRipple = false, sx }) => (
  <MatStepButton focusRipple={focusRipple || false} icon={icon} onClick={onClick} disableRipple={disableRipple} sx={sx}>
    {children}
  </MatStepButton>
);

StepButton.displayName = 'StepButton';

export { StepButton };
